import { Pipe, PipeTransform } from "@angular/core";
import { Observable, of, timer } from "rxjs";
import { map } from "rxjs/operators";
import { duration } from "../functions";

@Pipe({
  name: "duration$"
})
export class DurationPipe implements PipeTransform {
  transform(time: null | number): Observable<number> {
    if (!time) {
      return of(0);
    }

    return timer(0, 1_000).pipe(map(() => duration(time)));
  }
}
